<template>
  <div>
    <div class="pb-4">
      <PageHeader title="مدیریت دوره" :items="pageHeaderItems" />
    </div>

    <TabLink :items="links">
      <div v-if="!$route.path.includes('faculty')" class="d-flex">
        <b-button
          variant="danger"
          :class="{ disable: model.status !== 1 }"
          class="px-4"
          @click="
            $bvModal.show('reject')
            model.licenseStatus = 3
          "
          >رد</b-button
        >
        <b-button
          variant="primary"
          :class="{ disable: model.status !== 1 }"
          class="ms-2"
          @click="
            $bvModal.show('edit')
            model.licenseStatus = 2
          "
          >نیاز به اصلاح</b-button
        >
        <b-button
          variant="success"
          :class="{ disable: model.status !== 1 }"
          class="px-5 ms-2"
          @click="
            model.licenseStatus = 4
            changeStaus()
          "
          >تایید</b-button
        >
      </div>
      <b-button v-else variant="primary" :class="{ disable: model.status !== 0 && model.status !== 2 }" class="ms-2" @click="sendRequest">درخواست مجوز دوره</b-button>
    </TabLink>

    <div
      v-if="
        $route.fullPath !== '/list/shortuniversitypackages/add' &&
        $route.fullPath !== '/list/longuniversitypackages/add' &&
        $route.fullPath !== '/list/facultyshortuniversitypackages/add' &&
        $route.fullPath !== '/list/facultylonguniversitypackages/add' &&
        !$route.params.packageId
      "
      class="card p-3"
    >
      برای اضافه کردن این بخش ابتدا باید دوره را ثبت نمایید
    </div>
    <router-view v-else></router-view>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="reject" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title> رد درخواست</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت رد درخواست"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('reject')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="edit" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>نیاز به اصلاح</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت نیاز به اصلاح"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('reject')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import TabLink from '../../../components/common/TabLink.vue'
import Toast from '../../../components/common/Toast.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import moocCourseProvider from '../../../services/mooc/course'
// import moocPackageProvider from '../../../services/mooc/package'
export default {
  page: {
    title: 'مدیریت دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-packages',
  components: {
    TabLink,
    PageHeader,
    TextAreaInput,
    Toast,
  },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
      currentAvailableStatus: {},
      model: {
        productId: +this.$route.params.packageId,
        productType: 1,
        licenseStatus: 0,
        description: '',
      },
      error: false,
      message: '',
      addedHeadlines: false,
    }
  },
  computed: {
    links() {
      if (this.$route.params.packageId !== undefined) {
        return [
          {
            title: `${
              this.$route.path.includes('shortuniversitypackages') || this.$route.path.includes('facultyshortuniversitypackages') ? 'ثبت دوره جامع' : 'ثبت دوره یکساله'
            }   `,
            link:
              this.$route.params.packageId && this.$route.path.includes('facultyshortuniversitypackages')
                ? `/list/facultyshortuniversitypackages/detail/${this.$route.params.packageId}`
                : this.$route.params.packageId && this.$route.path.includes('facultylonguniversitypackages')
                ? `/list/facultylonguniversitypackages/detail/${this.$route.params.packageId}`
                : this.$route.params.packageId && !this.$route.path.includes('faculty') && this.$route.path.includes('shortuniversitypackages')
                ? `/list/shortuniversitypackages/detail/${this.$route.params.packageId}`
                : this.$route.params.packageId && !this.$route.path.includes('faculty') && this.$route.path.includes('longuniversitypackages')
                ? `/list/longuniversitypackages/detail/${this.$route.params.packageId}`
                : this.$route.path.includes('facultyshortuniversitypackages')
                ? '/list/facultyshortuniversitypackages/add'
                : this.$route.path.includes('facultylonguniversitypackages')
                ? '/list/facultylonguniversitypackages/add'
                : !this.$route.includes('faculty') && this.$route.path.includes('shortuniversitypackages')
                ? '/list/shortuniversitypackages/add'
                : '/list/longuniversitypackages/add',
          },
          {
            title: 'محتوا دوره',
            link: this.$route.path.includes('facultyshortuniversitypackages')
              ? `/list/facultyshortuniversitypackages/${this.$route.params.packageId}/universitypackagecourses`
              : this.$route.path.includes('facultylonguniversitypackages')
              ? `/list/facultylonguniversitypackages/${this.$route.params.packageId}/universitypackagecourses`
              : !this.$route.path.includes('faculty') && this.$route.path.includes('shortuniversitypackages')
              ? `/list/shortuniversitypackages/${this.$route.params.packageId}/universitypackagecourses`
              : `/list/longuniversitypackages/${this.$route.params.packageId}/universitypackagecourses`,
          },

          {
            title: 'اعضا',
            link: this.$route.path.includes('facultyshortuniversitypackages')
              ? `/list/facultyshortuniversitypackages/${this.$route.params.packageId}/users?pageNumber=1&perPage=20`
              : this.$route.path.includes('facultylonguniversitypackages')
              ? `/list/facultylonguniversitypackages/${this.$route.params.packageId}/users?pageNumber=1&perPage=20`
              : !this.$route.path.includes('faculty') && this.$route.path.includes('shortuniversitypackages')
              ? `/list/shortuniversitypackages/${this.$route.params.packageId}/users?pageNumber=1&perPage=20`
              : `/list/longuniversitypackages/${this.$route.params.packageId}/users?pageNumber=1&perPage=20`,
          },
        ]
      }
      return [
        {
          title: 'ثبت دوره',
          link: this.$route.path.includes('facultyshortuniversitypackages')
            ? '/list/facultyshortuniversitypackages/add'
            : this.$route.path.includes('facultylonguniversitypackages')
            ? '/list/facultylonguniversitypackages/add'
            : !this.$route.path.includes('faculty') && this.$route.path.includes('shortuniversitypackages')
            ? '/list/shortuniversitypackages/add'
            : '/list/longuniversitypackages/add',
        },
        { title: 'محتوا دوره', link: '#' },
        { title: 'اعضا', link: '#' },
      ]
    },
  },
  methods: {
    async sendRequest() {
      if (
        !['facultyshortuniversitypackages', 'facultylonguniversitypackages'].includes(this.$route.fullPath) &&
        this.$route.query.courseLength &&
        this.$route.query.courseLength > 0
      ) {
        this.model.licenseStatus = 1
        this.changeStaus()
      } else {
        this.error = true
        this.message = 'برای ارسال درخواست ابتدا باید محتوای دوره را اضافه نمایید'
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async fetchAvailableStatus() {
      if (this.$route.params.packageId) {
        const req = await moocCourseProvider.getAvailableStatus({
          productId: +this.$route.params.packageId,
          productType: 1,
        })
        if (req.status === 200) {
          this.model = req.data.data.output
          delete this.model.availableStatus
        }
      }
    },
    // async checkAddedCourse() {
    //   const req = await moocPackageProvider.getPackageCourseTable({
    //     key: 'universitypackagecourses',
    //     pageNumber: 1,
    //     pageSize: 10,
    //     fieldSearchs: [{ fieldName: 'PackageId', type: 'string', text: '1' }],
    //   })
    //   if (req.data && req.data.data.rows.length) {
    //     this.addedHeadlines = true
    //   } else {
    //     this.error = true
    //     this.message = 'برای ارسال درخواست ابتدا باید محتوای دوره را اضافه نمایید'
    //     setTimeout(() => {
    //       this.error = false
    //       this.message = ''
    //     }, 5000)
    //   }
    // },
    async changeStaus() {
      const req = await moocCourseProvider.updateAvailableStatus({
        productId: +this.$route.params.packageId,
        productType: 1,
        licenseStatus: +this.model.licenseStatus,
        description: this.model.description,
      })
      if (req?.data?.data?.isSuccessful) {
        this.message = 'وضعیت با موفقیت تغییر یافت.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        this.fetchAvailableStatus()
      } else {
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        setTimeout(() => {
          this.error = false
        }, 5000)
      }
    },
  },
  watch: {
    '$route.path'() {
      this.fetchAvailableStatus()
    },
  },
  mounted() {
    this.fetchAvailableStatus()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal.show .modal-dialog {
  min-width: 611px !important;
  width: 611px !important;
}

// ::v-deep .modal-body {
//   min-height: 400px !important;
// }

.disable {
  background: #ced4da;
  pointer-events: none;
  border-color: #ced4da;
}

::v-deep .labelStyle {
  align-self: baseline;
}
</style>
